export enum ApplicationLoginStatus {
	undefined = 0,
	invalid = 1,
	pending = 2,
	valid = 3,
}
